import * as React from "react";
const SvgFilterIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 12, viewBox: "0 0 18 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7 12V10H11V12H7ZM3 7V5H15V7H3ZM0 2V0H18V2H0Z", fill: "#183A60" }));
export default SvgFilterIcon;
